import { withInstall } from "../utils/index.mjs";
import _Picker from "./Picker.mjs";
const Picker = withInstall(_Picker);
var stdin_default = Picker;
import { pickerProps } from "./Picker.mjs";
export {
  Picker,
  stdin_default as default,
  pickerProps
};
